import { render, staticRenderFns } from "./newCaseData.vue?vue&type=template&id=2f1fa998&scoped=true"
import script from "./newCaseData.vue?vue&type=script&lang=js"
export * from "./newCaseData.vue?vue&type=script&lang=js"
import style0 from "./newCaseData.vue?vue&type=style&index=0&id=2f1fa998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1fa998",
  null
  
)

export default component.exports